<app-header-title>
  <span title>الأوقات الإضافية</span>
</app-header-title>

<app-general-calc-salary-inputs 
  #salaryInputs
  [currentLang]="currentLang"
  (formDataChanged)="onFormDataChanged($event)">
</app-general-calc-salary-inputs>

<div style="padding: 1rem 3rem; margin-bottom: 1rem;">
  <dx-button 
    text="{{'search' | translate}}"
    [width]="200"
    (onClick)="applyFilter()">
  </dx-button>
  
  <dx-button 
    style="margin-right: 1rem;"
    text="{{'reset' | translate}}"
    type="normal"
    [width]="200"
    stylingMode="outlined"
    (onClick)="resetFilter()">
  </dx-button>
  
  <!-- ✅ تغيير اسم الدالة -->
  <dx-button 
    style="margin-right: 1rem;"
    text="حفظ التعديلات"
    type="success"
    [width]="200"
    icon="save"
    (onClick)="saveExtraTimeData()">
  </dx-button>

  <!-- ✅ تغيير اسم الدالة والنص -->
  <dx-button 
    style="margin-right: 1rem;"
    text="اعتماد الأوقات الإضافية"
    type="success"
    [width]="200"
    icon="save"
    (onClick)="approveExtraTimeData()">
  </dx-button>

</div>

<!-- Grid الأول: تفاصيل الحضور والانصراف -->
<div class="publicsetting" style="padding: 0rem 3rem;">
  <h3 style="margin-bottom: 1rem;">تفاصيل الحضور والانصراف</h3>
  
  <dx-data-grid #grid class="dx-card wide-card" #dataGridVar 
    [dataSource]="customDataSource" 
    keyExpr='id'
    [showBorders]="false" 
    [focusedRowEnabled]="true"
    [width]="'100%'"  
    [focusedRowIndex]="0" 
    [allowColumnResizing]="true"
    [columnAutoWidth]="true" 
    [columnHidingEnabled]="false" 
    [showColumnLines]="false" 
    [columnMinWidth]="100"
    [rowAlternationEnabled]="false"
    [showRowLines]="false" 
    [errorRowEnabled]="false" 
    [rtlEnabled]="currentLang=='ar'?true:false"
    (onRowUpdating)="updateRow($event)">
     <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export> 
    <dxo-remote-operations [groupPaging]="true"></dxo-remote-operations>
    <dxo-pager [visible]="true"></dxo-pager>
    <dxo-paging [pageSize]="10"></dxo-paging>
    
    <!-- تفعيل التعديل -->
    <dxo-editing 
      mode="row" 
      [useIcons]="true" 
      [allowAdding]="false" 
      [allowDeleting]="false" 
      [allowUpdating]="true">
      <dxo-popup 
        title="تعديل قيمة الوقت الإضافي" 
        [showTitle]="true" 
        [width]="500"
        [height]="300">
      </dxo-popup>
    </dxo-editing>
    
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    
    <dxi-column 
      dataField="employeeName" 
      caption="{{'tableinfo.employee'|translate}}" 
      [allowEditing]="false"
      [width]="200">
    </dxi-column>

    <dxi-column 
      dataField="dateOfDay" 
      dataType="date" 
      [allowEditing]="false"
      caption="التاريخ"
      [width]="120">
    </dxi-column>

    <dxi-column 
      dataField="workDurationSystemName" 
      caption="فترة العمل"
      [allowEditing]="false"
      [width]="120">
    </dxi-column>

    <dxi-column 
      dataField="timeFrom" 
      caption="بدايه فترة العمل"
      dataType="time"
      [allowEditing]="false" 
      format='shortTime'
      [width]="100">
    </dxi-column>

    <dxi-column 
      dataField="timeTo" 
      caption="نهاية فترة العمل"
      dataType="time"
      [allowEditing]="false" 
      format='shortTime'
      [width]="100">
    </dxi-column>

    <dxi-column 
      dataField="actualAttend" 
      caption="موعد الحضور"
      dataType="time"
      [allowEditing]="false" 
      format='shortTime'
      [width]="100">
    </dxi-column>

    <dxi-column 
      dataField="actualLeave" 
      caption="موعد الانصراف"
      dataType="time"
      [allowEditing]="false" 
      format='shortTime'
      [width]="100">
    </dxi-column>

    <!-- ✅ تغيير الأعمدة للـ ExtraTime -->
    <dxi-column 
      dataField="attendanceEarly" 
      caption="دقائق الحضور المبكر"
      [allowEditing]="false"
      [width]="100">
    </dxi-column>

    <dxi-column 
      dataField="leaveAfterTime" 
      caption="دقائق الانصراف المتأخر"
      [allowEditing]="false"
      [width]="100">
    </dxi-column>

    <!-- ✅ العمود القابل للتعديل - extraTimeValue -->
    <dxi-column
      dataField="extraTimeValue"
      caption="قيمة الوقت الإضافي (قابل للتعديل)"
      dataType="number"
      [allowEditing]="true"
      [format]="{ type: 'fixedPoint', precision: 3 }"
      [width]="150">
      <dxi-validation-rule type="required" message="القيمة مطلوبة"></dxi-validation-rule>
      <dxi-validation-rule type="numeric" message="يجب إدخال رقم"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      dataField="isAbsence"
      caption="غياب"
      [allowEditing]="false"
      [width]="80"
      cellTemplate="absenceTpl">
    </dxi-column>

    <div *dxTemplate="let cell of 'absenceTpl'">
      {{ cell.value ? 'غياب' : '' }}
    </div>

  </dx-data-grid>
</div>

<!-- Grid الثاني: الملخص -->
<div class="grid-container" style="padding: 2rem 3rem; margin-top: 2rem;">
  <h3 style="margin-bottom: 1rem;">ملخص الأوقات الإضافية</h3>
  
  <dx-data-grid  
    [dataSource]="summuryDataSource" 
    [showBorders]="false" 
    [focusedRowEnabled]="true"
    [allowColumnResizing]="true"
    [width]="'100%'"  
    [columnHidingEnabled]="false" 
    [showColumnLines]="false" 
    [columnMinWidth]="100"
    [rowAlternationEnabled]="false"
    [showRowLines]="false" 
    [errorRowEnabled]="false" 
    [rtlEnabled]="currentLang=='ar'?true:false">
    
    <dxo-pager [visible]="true"></dxo-pager>
    <dxo-paging [pageSize]="10"></dxo-paging>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    
    <dxi-column 
      dataField="employeeNameAr" 
      caption="{{'tableinfo.employee'|translate}}" 
      [width]="200">
    </dxi-column>
    
    <dxi-column 
      dataField="fromDate" 
      dataType="date" 
      caption="من تاريخ" 
      [width]="120">
    </dxi-column>
    
    <dxi-column 
      dataField="toDate" 
      dataType="date" 
      caption="الي تاريخ" 
      [width]="100">
    </dxi-column>
    
    <!-- ✅ تغيير من delayValues إلى extraTimeValues -->
    <dxi-column 
      dataField="extraTimeValues" 
      dataType="number" 
      caption="إجمالي الوقت الإضافي (محدث)" 
      [width]="150"
      [format]="{ type: 'fixedPoint', precision: 3 }">
    </dxi-column>
    
    <dxi-column 
      dataField="mainSalary" 
      dataType="number" 
      caption="الراتب الشهري" 
      [width]="100"
      [format]="{ type: 'fixedPoint', precision: 3 }">
    </dxi-column>
    
    <dxi-column 
      dataField="salaryDayValue" 
      dataType="number" 
      caption="الراتب اليومي" 
      [width]="100"
      [format]="{ type: 'fixedPoint', precision: 3 }">
    </dxi-column>

  </dx-data-grid>
</div>